import { c as _c } from "react/compiler-runtime";
import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { parseJson } from '@/utils/string';
import { flagsContext } from './LaunchDarklyProvider';
import { useEnvironment } from './useEnvironment';
export const useFeatureFlags = () => {
  const $ = _c(7);
  const conductedFlags = useFlags(flagsContext);
  const searchParams = useSearchParams();
  let t0;
  let t1;
  if ($[0] !== conductedFlags || $[1] !== searchParams) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const flagsOverrides = searchParams.get("flags");
      if (!flagsOverrides) {
        t1 = conductedFlags;
        break bb0;
      }
      t0 = flagsOverrides.split(",").reduce(_temp, {});
    }
    $[0] = conductedFlags;
    $[1] = searchParams;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  const flags = t0;
  let t2;
  if ($[4] !== conductedFlags || $[5] !== flags) {
    t2 = {
      ...conductedFlags,
      ...flags
    };
    $[4] = conductedFlags;
    $[5] = flags;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export const useLaunchDarkly = () => {
  const $ = _c(5);
  const {
    isDemo,
    isDev,
    isTest
  } = useEnvironment();
  const [ldClientReady, setLDClientReady] = useState(isDemo || isDev || isTest);
  const ldClient = useLDClient(flagsContext);
  let t0;
  let t1;
  if ($[0] !== ldClient) {
    t0 = () => {
      ldClient?.waitUntilReady().then(() => setLDClientReady(true));
    };
    t1 = [ldClient];
    $[0] = ldClient;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== ldClientReady) {
    t2 = {
      isReady: ldClientReady
    };
    $[3] = ldClientReady;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(acc, flag) {
  const parts = flag.split(":");
  const [key, value] = parts;
  if (parts.length === 1) {
    return {
      ...acc,
      [key]: true
    };
  }
  const parsedValue = parseJson(value);
  return {
    ...acc,
    [key]: parsedValue === undefined ? value : parsedValue
  };
}